var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',[_c('CCol',[_c('CCard',[_c('CCardBody',[[_c('CIcon',{staticClass:"text-danger",staticStyle:{"margin-bottom":"5px"},attrs:{"name":"cil-briefcase"}}),_c('label',{staticStyle:{"padding-left":"12px"},domProps:{"textContent":_vm._s(_vm.partnerName)}})]],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }